import pino from "pino"

// Detectar ambiente (navegador vs Node.js)
const isServer = typeof window === "undefined"
const isDevelopment = process.env.NODE_ENV !== "production"

// Configurações avançadas do Pino para projeto de grande porte
const pinoConfig = {
  level: isDevelopment ? "debug" : "info",

  // Redação de dados sensíveis
  redact: {
    paths: ["password", "token", "authorization", "*.credentials.*", "headers.authorization"],
    censor: "[REDACTED]",
  },

  // Formatação personalizada para ambiente de desenvolvimento
  transport:
    isDevelopment && isServer
      ? {
          target: "pino-pretty",
          options: {
            colorize: true,
            translateTime: "SYS:standard",
            ignore: "pid,hostname",
          },
        }
      : undefined,

  // Configuração de browser quando executando no navegador
  browser: {
    asObject: true, // Mantém os logs como objetos no console
    transmit: {
      level: "error", // Envia apenas erros para o servidor
      send: (level, logEvent) => {
        // Aqui você pode implementar o envio de logs para um endpoint
        // Exemplo:
        // fetch('/api/logs', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify(logEvent)
        // }).catch(() => {});
      },
    },
  },

  // Serialização personalizada para objetos comuns
  serializers: {
    error: pino.stdSerializers.err,
    req: pino.stdSerializers.req,
    res: pino.stdSerializers.res,
    // Serialização customizada para objetos específicos do projeto
    user: (user) => ({
      id: user?.id,
      email: user?.email,
      // evita serializar dados sensíveis
    }),
  },

  // Inclusão automática de metadados
  base: {
    app: "talk-web",
    env: process.env.NODE_ENV,
  },
}

// Logger principal
export const logger = pino(pinoConfig)

// Hook para registrar exceções não tratadas (apenas no servidor)
if (isServer) {
  process.on("uncaughtException", (err) => {
    logger.fatal(err, "Uncaught Exception")
    process.exit(1)
  })

  process.on("unhandledRejection", (reason, promise) => {
    logger.error({ reason, promise }, "Unhandled Rejection")
  })
}

// Para ambiente de navegador, capturar erros não tratados
if (!isServer) {
  window.addEventListener("error", (event) => {
    logger.error(
      {
        message: event.message,
        source: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
      },
      "Uncaught browser error",
    )
  })

  window.addEventListener("unhandledrejection", (event) => {
    logger.error(
      {
        reason: event.reason,
      },
      "Unhandled promise rejection",
    )
  })
}
